import React from "react";
import { SlideHome } from "../../components/home/slideHome";
import { SectionNumber } from "../../components/home/sectionNumber";
import { SimulationSection } from "../../components/home/simulationSection";
import ServicesSection from "../../components/home/servicesSection";
import CoreValues from "../../components/home/coreValues";
import ConsultantProfiles from "../../components/home/consultantProfiles";
import { Temoignage } from "../../components/home/teamoignage";
import FAQ from "../../components/home/faqs";

export const HomePage = () => {
  return (
    <div>
      <SlideHome />
      <SectionNumber />
      <SimulationSection />
      <ServicesSection />
      <CoreValues />
      <ConsultantProfiles />
      <Temoignage />
      <FAQ />
    </div>
  );
};
